export default __webpack_public_path__ + "static/media/CDIpromo_582x700.43cfb7ca.jpg";